<template>
  <div>
    <div style="margin-top: 8px; margin-left: 8px">
      <el-button @click="search(1)"> 查询 </el-button>
    </div>
    <el-descriptions
      style="margin-top: 8px; margin-left: 8px"
      :column="2"
      size="mini"
      border
    >
      <el-descriptions-item label="税号">
        <el-input
          size="mini" clearable
          v-model="searchForm.tax_no"
          placeholder="输入税号搜索"
        ></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="日期">
        <el-date-picker
          v-model="searchForm.dateRange"
          type="daterange" value-format="yyyyMMdd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="mini"
        ></el-date-picker>
      </el-descriptions-item>
    </el-descriptions>
    <el-table
      style="margin-top: 8px; margin-left: 8px"
      max-height="600"
      :data="listData"
      border
    >
      <el-table-column label="发票税号" prop="tax_no" />
      <el-table-column label="公司名称" prop="tax_name" />
      <el-table-column label="发票数量" prop="invoice_num" />
      <el-table-column label="发票金额" prop="invoice_order_total" />
      <el-table-column label="线上开票数量" prop="online_invoice_num" />
      <el-table-column label="线上开票金额" prop="online_invoice_order_total" />
      <el-table-column label="手机开票数量" prop="mobile_invoice_num" />
      <el-table-column label="手机开票金额" prop="mobile_invoice_order_total" />
    </el-table>
    <div class="pages" v-if="listData">
<!--      <Page-->
<!--        :total="searchForm.totalCount"-->
<!--        :page-size="searchForm.pageSize"-->
<!--        @on-change="search"-->
<!--        show-total-->
<!--      />-->
    </div>
  </div>
</template>

<script>
export default {
  name: "FinanceInvoiceStatistics",
  data() {
    return {
      listData: [],
      searchForm: {
        taxNumber: "",
        dateRange: [],
        page: 1,
        pageSize: 10,
        totalCount: 0,
      },
    };
  },
  mounted() {
    // 默认时间筛选当月
    let firstDay = new Date(
      new Date().getFullYear(),
      new Date().getMonth() ,
      1
    );
    let lastDay = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      0
    );
    this.searchForm.dateRange = [
      firstDay.getFullYear().toString() + (firstDay.getMonth() + 1).toString().padStart(2, '0') + "01",
      lastDay.getFullYear().toString() + (lastDay.getMonth() + 1).toString().padStart(2, '0') + lastDay.getDate().toString().padStart(2, '0')
    ];
    this.search(1);
  },
  methods: {
    search(page) {
      this.searchForm.page = page;
      console.log(this.searchForm.dateRange)
      if (this.searchForm.dateRange && this.searchForm.dateRange.length > 0) {
        // 转换日期格式
        console.log(this.searchForm.dateRange[0])
        this.searchForm.start_time = this.searchForm.dateRange[0];
        this.searchForm.end_time = this.searchForm.dateRange[1];
      } else {
        this.searchForm.start_time = "";
        this.searchForm.end_time = "";
      }
      let that = this;
      this.$myhttp
        .post("admin/InvoiceStatics/index", this.searchForm, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          console.log(backdata)
          if (backdata.data.code === 200) {
            that.listData = backdata.data.data.list;
            that.searchForm.totalCount = backdata.data.data.count;
          } else {
            that.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Finance/invoiceStatic.vue